import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
	name: 'boldFilter',
	pure: false
})
export class BoldPipeFilter implements PipeTransform {
	transform(value: string, query: string): string {
		return value.replace(
			new RegExp(query, 'gi'),
			match => `<strong>${match}</strong>`
		);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./shared/pipes/bold/boldPipe.ts